import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-16dc387c")
const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "text-subtitle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1)
const _hoisted_4 = { class: "flex-wrap d-flex" }
const _hoisted_5 = ["data-node"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "px-2 widget-item-title" }
_popScopeId()

import { withDefaults } from 'vue'
import stepTemplates from './Step'

interface IProps {
  drag?: (ev: Event) => void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    drag: { type: Function, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { drag: (ev: Event) => void }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('overlay.widget.title')), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('overlay.widget.subtitle')), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stepTemplates), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "py-2 rounded-lg ma-1 drag-drawflow d-flex align-center flex-column widget",
          draggable: "true",
          onDragstart: _cache[0] || (_cache[0] = ($event: any) => (props.drag($event))),
          "data-node": item.type
        }, [
          _createElementVNode("img", {
            src: item.icon,
            height: "32"
          }, null, 8, _hoisted_6),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(item.title)), 1)
        ], 40, _hoisted_5))
      }), 128))
    ])
  ], 64))
}
}

})